import { BaseTableStateHandler } from "@hooks/use-table-context/utils";
import { 
    TicketTableData, 
    TicketTableContextValue, 
    TicketTableFilter,
} from "./types"

export { TICKET_KEY_FOR_ASSETS } from "../../../utils/types";

export const TICKET_FILTER_TABLE_KEY = "tickets";
// Bump whenever a filterable Ticket field is renamed/removed so stale
// persisted filters are discarded instead of silently reapplied.
export const TICKET_FILTER_SCHEMA_VERSION = 1;

export class TicketTableStateHandler extends BaseTableStateHandler<TicketTableData, TicketTableFilter> {
    state: TicketTableContextValue;
    
    constructor(state: TicketTableContextValue) {
        super(state);
        this.state = state;
    }

    //CUSTOM ACTION FOR TICKET CONTEXT TO TOGGLE SHOW CLOSED TICKETS
    ["TOGGLE_SHOW_CLOSED_TICKETS"]() {
        this.state = {
            ...this.state,
            loading: true,
            showClosed: !this.state.showClosed,
        };
    }
}